export * as folders from '@wix/auto_sdk_autocms-folders-service_folders/meta';
